import React, { useEffect, useRef, useState } from "react";
import { Image } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { useNavigate, useParams } from "react-router";
import "../../styles/Employees/employeeScreenshot.scss";
import { commonPostservice } from "../../utils/properties";
import { showToast } from "../../features/Toaster/toastslice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { setDate } from "../../features/date/dashboardSlice";

interface ScreenShots {
    url: string;
    description: string;
    device_id: string;
    emp_name: string;
    emp_code: string;
}

const EmployeesScreenshot = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const containerRef = useRef<HTMLDivElement>(null)
    const screenshotCardRef = useRef<HTMLDivElement>(null)
    const [containerWidth, setContainerWidth] = useState(0);
    const filterData = useAppSelector((state) => state.filterData);
    const showScreenshot = process.env.REACT_APP_DISPLAY_SCREENSHOT;

    const {
        startDate,
        endDate,
        empDeviceId,
        filterType,
        organization,
        department,
        filterChosen,
    } = filterData;

    const [cardsLength, setCardsLength] = useState(0)
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [screenshots, setScreenshots] = useState<Record<string, ScreenShots[]>>({});
    const { empid } = useParams();

    const dateKeys = Object.keys(screenshots).sort(
        (a, b) => new Date(b).getTime() - new Date(a).getTime()
    );

    const formatDate = (date: string) =>
        new Date(date).toDateString();



    const arr = Array(4).fill(0);
    // const showScreenshot = "TRUE";



    useEffect(() => {
        const resizeObserver = new ResizeObserver(entries => {
            setContainerWidth(entries[0].contentRect.width);
        });

        if (containerRef.current) {
            resizeObserver.observe(containerRef.current);
        }

        return () => resizeObserver.disconnect();
    }, []);
    useEffect(() => {
        if (!containerRef.current || !screenshotCardRef.current) return;

        const containerWidth = containerRef.current.getBoundingClientRect().width;

        const card = screenshotCardRef.current;
        const rect = card.getBoundingClientRect();
        const style = getComputedStyle(card);

        const marginLeft = parseFloat(style.marginLeft) || 0;
        const marginRight = parseFloat(style.marginRight) || 0;

        const totalCardWidth = rect.width + marginLeft + marginRight;

        const cardsPerRow = Math.max(
            1,
            Math.floor(containerWidth / totalCardWidth)
        );
        setCardsLength(cardsPerRow)
    }, [containerWidth]);

    useEffect(() => {
        if (cardsLength === 0) return
        else {
            setIsLoading(true);
            let fromDate = moment(startDate).format("YYYY-MM-DD");
            let toDate = moment(endDate).format("YYYY-MM-DD");
            commonPostservice(`/api/1.0/employee/screenshot?empCode=${empid ?? empDeviceId}&page=0&size=${cardsLength}&fromDate=${fromDate}&toDate=${toDate}`, {}).then((res) => {
                if (res.status === 200) {
                    setScreenshots(res?.data);
                } else {
                    dispatch(
                        showToast({
                            message: "Something went wrong in API.",
                            status: "retry",
                            visible: true,
                        })
                    );
                }
                setIsLoading(false);

            })
        }

    }, [cardsLength, startDate,
        endDate, empid])


    const todayKey = new Date().toLocaleDateString("en-CA");
    // gives YYYY-MM-DD in local time
    return (
        <div className="emp-sst-container" ref={containerRef}>


            {dateKeys.length || isLoading ? (
                (isLoading ? [1, 2, 3] : dateKeys).map((dateKey, i) => {
                    const dayScreenshots = screenshots[dateKey] || [];
                    return (
                        <React.Fragment key={dateKey || i}>
                            {/* Header */}
                            <div className="d-flex flex-row justify-content-between common-card-title">
                                <h5>{isLoading ? <Skeleton width={150} /> : dateKey === todayKey ? "Recent Screenshots" : formatDate(String(dateKey))}</h5>

                                {dayScreenshots.length > 0 && !isLoading && (
                                    <div className="report-link" onClick={() => {
                                        if (filterChosen === "Range") {
                                            dispatch(setDate({ startDate: new Date(dateKey), endDate: new Date(dateKey) }))
                                        }
                                        navigate("/screenshots")
                                    }}>
                                        View all
                                    </div>
                                )}
                            </div>

                            {/* Images */}
                            <div className="sct-img-cont d-flex flex-row">
                                {(isLoading ? arr : dayScreenshots).map((item, index) => (
                                    <div className="sct-img d-flex flex-column" key={index} ref={screenshotCardRef}>
                                        <div>
                                            {isLoading ? (
                                                <Skeleton className="sst-img" />
                                            ) : (
                                                <Image
                                                    src={
                                                        showScreenshot === "TRUE"
                                                            ? item.url
                                                            : "/images/screenshots/screenshots.jpg"
                                                    }
                                                    alt="Screenshot"
                                                    className="sst-img"
                                                />
                                            )}
                                        </div>

                                        <div className="sct-details d-flex flex-column">
                                            <h6>{isLoading ? <Skeleton width={80} /> : item.emp_name}</h6>

                                            <div className="d-flex justify-content-between emp-id w-100">
                                                <p>{isLoading ? <Skeleton width={60} /> : item.emp_code}</p>
                                                <p>{isLoading ? <Skeleton width={100} /> : item.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </React.Fragment>
                    );
                })
            ) : (
                <div className="no-data-row">
                    <div className="no-data-image-wrapper"><Image src="/images/dashboard/folder_icon.svg" /></div>
                    <p>No Screenshots to show</p>
                </div>
            )}



        </div>
    );
};

export default EmployeesScreenshot;
